/**
 * Password validation utility
 * Requirements:
 * - Minimum 9 characters
 * - Must include at least 3 of 4: lowercase, uppercase, number, special character
 * - No spaces allowed
 * - No more than 2 identical characters in a row
 */

export function validatePassword(password) {
  const errors = [];

  if (!password || typeof password !== 'string') {
    return { valid: false, errors: ['Password is required'] };
  }

  // Minimum length
  if (password.length < 9) {
    errors.push('Password must be at least 9 characters long');
  }

  // Check for spaces
  if (/\s/.test(password)) {
    errors.push('Password cannot contain spaces');
  }

  // Check for 3+ identical characters in a row
  if (/(.)\1\1/.test(password)) {
    errors.push('Password cannot have 3 or more identical characters in a row');
  }

  // Check character requirements (at least 3 of 4)
  const hasLowercase = /[a-z]/.test(password);
  const hasUppercase = /[A-Z]/.test(password);
  const hasNumber = /\d/.test(password);
  const hasSpecial = /[^A-Za-z0-9]/.test(password);

  const requirementsMet = [hasLowercase, hasUppercase, hasNumber, hasSpecial].filter(Boolean).length;

  if (requirementsMet < 3) {
    const missing = [];
    if (!hasLowercase) missing.push('lowercase letter');
    if (!hasUppercase) missing.push('uppercase letter');
    if (!hasNumber) missing.push('number');
    if (!hasSpecial) missing.push('special character');
    
    // Require at least 3 of 4, so user needs to add (3 - requirementsMet) more
    const needed = 3 - requirementsMet;
    if (needed > 0) {
      const missingList = missing.slice(0, needed);
      const hasStr = requirementsMet === 1 ? 'has' : 'have';
      const needsStr = needed === 1 ? 'more' : 'more';
      errors.push(`Password must include at least 3 of 4 character types (lowercase, uppercase, number, special character). Currently ${hasStr} ${requirementsMet}, needs ${needed} ${needsStr}: ${missingList.join(', ')}`);
    }
  }

  return {
    valid: errors.length === 0,
    errors
  };
}

export function validatePasswordMatch(password, confirmPassword) {
  if (!confirmPassword || typeof confirmPassword !== 'string') {
    return { valid: false, error: 'Please confirm your password' };
  }

  if (password !== confirmPassword) {
    return { valid: false, error: 'Passwords do not match' };
  }

  return { valid: true, error: null };
}

